import Vue from 'vue';
import VueRouter from 'vue-router';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import AirStats from '@/views/stats/AirStats.vue';
import RegosStats from '@/views/stats/RegosStats.vue';
import RegosParts from '@/views/RegosParts.vue';
import ProductsOnLocation from '@/views/checks/ProductsOnLocation.vue';
import ConfirmReceived from '@/views/checks/ConfirmReceived.vue';
import TotalStockValue from '@/views/stats/TotalStockValue.vue';
import Home from '@/views/Home.vue';
import Scanner from '@/views/Scanner.vue';
import ManualInput from '@/views/ManualInput.vue';
import Info from '@/views/Info.vue';
import Login from '@/views/Login.vue';
import LagerList from '@/views/LagerList.vue';
import LocalStock from '@/views/LocalStock.vue';
import Stats from '@/views/stats/Stats.vue';
import ProductHistory from '@/views/stats/ProductHistory.vue';
import WorkshopStats from '@/views/stats/WorkshopStats.vue';
import WebStats from '@/views/stats/WebStats.vue';
import PolandStats from '@/views/stats/PolandStats.vue';
import Overview from '@/views/stats/Overview.vue';
import Virtuals from '@/views/Virtuals.vue';
import PolandOrders from '@/views/PolandOrders.vue';
import ProcessedOrders from '@/views/ProcessedOrders.vue';
import MobileScanner from '@/views/MobileScanner.vue';
import Invoices from '@/views/invoices/Invoices.vue';
import InvoiceList from '@/views/invoices/InvoiceList.vue';
import PendingInvoices from '@/views/invoices/PendingInvoices.vue';
import NewInvoice from '@/views/invoices/NewInvoice.vue';

import Companies from '@/views/invoices/Companies.vue';
import NewCompany from '@/views/invoices/NewCompany.vue';
import Client from '@/views/invoices/Client.vue';
import Reports from '@/views/invoices/Reports.vue';
import MerchantOrder from '@/views/MerchantOrder.vue';
import MerchantOrderHistory from '@/views/MerchantOrderHistory.vue';
import MerchantPOS from '@/views/MerchantPOS.vue';
import RefLager from '@/views/refLager/RefLager.vue';
import PackedOrders from '@/views/PackedOrders.vue';
import Transport from '@/views/Transport.vue';
import AS from '@/views/airsuspension/AS.vue';
import EanScan from '@/views/airsuspension/EanScan.vue';
import ProductsList from '@/views/airsuspension/ProductsList.vue';
import OrderSuggestions from '@/views/supplies/OrderSuggestions.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/invoices',
    component: Invoices,
    children: [
      {
        path: '/',
        component: InvoiceList,
      },
      {
        path: 'pending-invoices',
        component: PendingInvoices,
      },
      {
        path: 'new-invoice',
        component: NewInvoice,
      },
      {
        path: 'companies',
        component: Companies,
        name: 'companies',
      },
      {
        path: 'new-company',
        component: NewCompany,
      },
      {
        path: 'client/:id',
        name: 'client',
        component: Client,
      },
      {
        path: 'reports',
        component: Reports,
        name: 'reports',
      },
    ],
  },
  {
    path: '/scanner',
    name: 'scanner',
    component: Scanner,
    // component: () => import(/* webpackChunkName: "scanner" */ '../views/Scanner.vue'),
  },
  {
    path: '/manual',
    name: 'manual',
    component: ManualInput,
  },
  {
    path: '/qtt/:ean',
    name: 'quantity',
    component: Info,
  },
  {
    path: '/lager-list',
    name: 'lager-list',
    component: LagerList,
  },
  {
    path: '/local-stock/:codename?',
    name: 'local-stock',
    component: LocalStock,
  },
  {
    path: '/regos-parts',
    name: 'regos-parts',
    component: RegosParts,
  },
  {
    path: '/ref-lager',
    name: 'ref-lager',
    component: RefLager,
  },
  {
    path: '/as',
    name: 'airsuspension',
    component: AS,
    children: [
      {
        path: 'scan',
        component: EanScan,
      },
      {
        path: 'products',
        component: ProductsList,
      },
    ],
  },
  {
    path: '/stats',
    name: 'stats',
    component: Stats,
    children: [
      {
        path: 'history',
        component: ProductHistory,
      },
      {
        path: 'workshop-stats',
        component: WorkshopStats,
      },
      {
        path: 'poland-stats',
        component: PolandStats,
      },
      {
        path: 'website-stats',
        component: WebStats,
      },
      {
        path: 'regos-stats',
        component: RegosStats,
      },
      {
        path: 'as-stats',
        component: AirStats,
      },
      {
        path: 'invoices',
        component: Reports,
      },
      {
        path: 'total-stock-value',
        component: TotalStockValue,
      },
      {
        path: 'overview',
        component: Overview,
      },
    ],
  },
  {
    path: '/order-suggestions',
    name: 'order-suggestions',
    component: OrderSuggestions,
  },
  {
    path: '/virtuals',
    name: 'virtuals',
    component: Virtuals,
  },
  {
    path: '/poland-orders',
    name: 'poland-orders',
    component: PolandOrders,
  },
  {
    path: '/processed-orders',
    name: 'processed-orders',
    component: ProcessedOrders,
  },
  {
    path: '/mobile-scanner',
    name: 'mobile-scanner',
    component: MobileScanner,
  },
  {
    path: '/packed-orders',
    name: 'packed-orders',
    component: PackedOrders,
  },
  {
    path: '/transport-scan',
    name: 'transport-scan',
    component: Transport,
  },
  {
    path: '/products-on-location',
    name: 'products-on-location',
    component: ProductsOnLocation,
  },
  {
    path: '/confirm-received',
    name: 'confirm-received',
    component: ConfirmReceived,
  },
  {
    path: '/merchant-order',
    name: 'merchant-order',
    component: MerchantOrder,
  },
  {
    path: '/merchant-order-history',
    name: 'merchant-order-history',
    component: MerchantOrderHistory,
  },
  {
    path: '/merchant-pos',
    name: 'merchant-pos',
    component: MerchantPOS,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// Cheap client-side guard: gate navigation on a locally-stored login marker
// instead of pinging the API on every route change. Real session validity is
// enforced server-side and any expiry surfaces as a 401, which the global
// axios interceptor turns into a redirect back here.
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('user');

  if (to.name !== 'login' && !isAuthenticated) {
    next({ name: 'login' });
    return;
  }

  next();
});

export default router;
